import { translateField } from "@cdv/jazz-i18n";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { ReactElement, useContext } from "react";
import AppBar from "../ui/AppBar";
import { Resource } from "../utils";
import { useNavigate } from "react-router";
import { ActionType, AppContext, useRouterParams } from "@cdv/jazz-ui";
import { PageContext } from "../App/Context/PageContext";
import RenderContent from "../Content/Content";

export default function CardShow(): ReactElement {
  const navigate = useNavigate();
  const { getUrl } = useContext(AppContext);
  const { tests } = useContext(PageContext);
  const { id } = useRouterParams();

  const test = tests?.find((t) => t.id === id);

  if (!test) return <></>;

  return (
    <>
      <AppBar title={translateField(Resource.TestDefinition, "title")} />

      <Card sx={{ mx: "16px", mb: "60px", borderRadius: 0, boxShadow: "none" }}>
        <CardContent>
          <Stack sx={{ alignItems: "center", mt: "5px" }}>
            <img src="/assets/09_ilustr_stres_01.svg" style={{ height: "155px" }} />
          </Stack>

          <Typography sx={{ textAlign: "center", mt: "10px", fontSize: "20px" }} variant="h5">
            {test.name}
          </Typography>

          <Box sx={{ p: { color: "#00000099" } }}>
            <RenderContent contentValue={test.description} />
          </Box>

          <Stack sx={{ alignItems: "center", mt: "10px" }} spacing={2}>
            {test.versions.map((version) => (
              <Button
                key={version.id}
                variant="contained"
                color="warning"
                size="large"
                fullWidth
                onClick={() =>
                  navigate(
                    getUrl(
                      Resource.TestVersion,
                      ActionType.SHOW,
                      {
                        id: version.id,
                      },
                      test.id,
                    ),
                  )
                }
              >
                {version.name}
              </Button>
            ))}
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
